<template>
  <div @click.stop="peopleInfoPanClick" class="dropdown_people">
    <div class="people_info">
      <el-tabs v-model="activeName">
        <el-tab-pane v-for="(item, i) in labels" :key="i" :label="item.groupName" :name="item.groupName">
          <div style="height: 330px;overflow: auto;">
            <div v-if="item.type == 'profile'" style="overflow: auto;width: 100%;height: 100%;">
              <UserProfileObjs v-model="profileData" ref="UserProfileObjs"></UserProfileObjs>
              <div class="clear"></div>
            </div>
            <div v-else style="padding: 15px;">
              <!-- :isMuilt="item.selectType == '2'" -->
              <SpeGroup :list="item.list" v-model="dist[item.group]" :isMuilt="true" :limit="item.limit"></SpeGroup>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <div class="footer">
      <el-button size="mini" @click="cancelTags">取消</el-button>
      <el-button class="save" @click="saveCondition" size="mini">保存</el-button>
    </div>
  </div>
</template>

<script>
import SpeGroup from '@/views/PutOrder/components/OrderForm/SpeGroup'
import UserProfileObjs from '@/views/PutOrder/components/OrderForm/UserProfileObjs'
import searchLabelsMix from '@/utils/searchLabelsMix'
export default {
  name: "PeopleInfo",
  mixins: [ searchLabelsMix ],
  components: { SpeGroup, UserProfileObjs },
  props: [ 'value' ],
  data () {
    return {
      list: [],
      result: [],
      activeName: '',

      curSpeTabI: 0,
      curGroup: {
        noShowGpName: false,
        list: []
      },
      dist: {},
      profileData: [],
      profileDataConfirm: []
    }
  },
  computed: {
    noSelect () {
      return list => {
        if (!this.result.length) return true
        let choose = 0
        list.forEach(el => {
          if (this.result.indexOf(el.code) > -1) choose = choose + 1
        })
        if (choose > 0) return false
        else return true
      }
    },
    curSelect () {
      return el => {
        if (!this.result.length) return false
        return this.result.indexOf(el.code) > -1
      }
    },
    labels () {
      let commonList = this.$store.state.label.list
        .filter(el => el.kind == 'NBHD')
        .reduce((res, cur) => res.concat(cur.groups), [])
        .map(el => {
          el.list = el.labels.map(ele => {
            let { name, code, groupName, kindName } = ele
            return { ...ele, label: name, labelValue: code, codeName: groupName, typeName: kindName }
          })
          return el
        })
      return [ ...commonList, { type: 'profile', groupName: '用户画像' } ]
    }
  },
  created () {
    // 组件展示时 根据父组件中保存已选的数据来处理 组件中dist数据的变更
    // 须深拷贝，如果不深拷贝，勾选时会导致父级组件中同一份内存数据变更，会触发请求
    // 须$set, dist声明时为空对象，不能让子组件speGroup的props中value及时响应获取变化
    let copyValue = JSON.parse(JSON.stringify(this.value))
    Object.keys(copyValue).forEach(el => {
      this.$set(this.dist, el, copyValue[el])
    })
  },
  watch: {
    value: {
      immediate: true,
      handler (v) {
        if (v.personsLabelData) this.profileData = v.personsLabelData
      }
    },
    labels: {
      immediate: true,
      handler(v) {
        // 初始化选中第一个tab
        if (v.length && !this.activeName) this.activeName = v[0].groupName
      }
    }
  },
  methods: {
    peopleInfoPanClick () {
      let userProfileCp = this.$refs.UserProfileObjs
      if (Array.isArray(userProfileCp)) userProfileCp = userProfileCp[0]
      if (userProfileCp) userProfileCp.closePopovers()
    },
    handleLabelOriginList (list) { // 原始数据变成组件需要的数据
      list.forEach(el => {
        el.list = el.labelResponses || []
        el.list.forEach(ele => {
          ele.limit = el.limit
          ele.list = (ele.lableDetailsResponses || []).map(elem => {
            return { ...elem, label: elem.context, labelValue: elem.code, codeName: ele.codeName, typeName: el.typeName }
          })
        })
        return el
      })
    },
    chooseItem (el, list, selectType) { // 点击切换选中状态
      let rmListAllItem = array => {
        array.forEach(element => {
          let idx = this.result.indexOf(element.code)
          if (idx > -1) this.result[idx] = null
        })
      }
      if (el) {
        let idx = this.result.indexOf(el.code)
        if (idx > -1) this.result.splice(idx, 1)
        else {
          if (selectType && selectType === '1') rmListAllItem(list)
          this.result.push(el.code)
        }
      } else { // 不限
        if (!list) return
        rmListAllItem(list)
      }
      this.result = this.result.filter(el => el)
    },
    cancelTags () {
      this.profileData = JSON.parse(JSON.stringify(this.profileDataConfirm))
      this.$emit('close')
    },
    getNbhdLabels (dist) {
      return Object.values(this.dist)
        .reduce((res, cur) => res.concat(cur), []) // 选择的所有标签属性集合（不包括用户画像）
        .filter(el => el.kind== 'NBHD') // 选取的{小区属性}的相关集合
        .map(el => el.code)
    },
    handlePfParam (list) {
      return list.filter(el => el.list && el.list.length).map(el => el.list.map(el => el.code))
    },
    hasSame (list) {
      let all = list.map(el => el.list.map(el => el.code).sort().join('')).filter(el => el)
      let set = [...new Set(all)]
      return all.length > set.length
    },
    saveCondition () {
      if (this.hasSame(this.profileData)) return this.messageTip('画像数据不能重复', 2)
      this.profileDataConfirm = this.profileData
      // this.$emit('input', this.getResult(this.result))
      // 此组件是v-if在父级组件中使用，再次点击展示无法重新勾选已选的标签，所以
      // 已选择的数据 emit 保存到父级组件，当再次展示组件时根据数据来处理已选择的数据重新勾选状态
      this.$emit('input', this.dist)
      let pfData = this.profileDataConfirm
      this.$emit('profileChange', pfData)
      this.cancelTags()
      // 参数相关数据传递到 label store 里  供地图搜索请求接口时使用
      this.$store.commit('label/setStore', { key: ['operate', 'labels'], value: this.getNbhdLabels(this.dist) })
      this.$store.commit('label/setStore', { key: ['operate', 'persons'], value: this.handlePfParam(pfData) }) // 用户画像数据
      this.$store.commit('label/setStore', { key: ['operate', 'personsData'], value: pfData.filter(el => el.list.length) }) // 用户画像数据
    }
  }
}
</script>

<style lang="scss" scoped>
.dropdown_people {
  width: 420px;
  position: absolute;
  left: 10px;
  top: 60px;
  background: #FFF;
  border-radius: 4px;
  box-shadow: 0 6px 12px 0 rgba(40, 39, 41, 0.2);
  padding-top: 20px;
  z-index: 2;
  .people_info {
    overflow: auto;
    text-align: center;
    > div {
      text-align: left;
      margin: 0 auto;
    }
    span {
      display: inline-block;
      position: relative;
      width: 87px;
      line-height: 30px;
      border: 1px solid #E9E9E9;
      margin: 5px;
      font-size: 12px;
      cursor: pointer;
      text-align: center;
      img {
        display: none;
        position: absolute;
        top: 0;
        right: 0;
      }
      &.select {
        border-color: #282729;
        img {
          display: block;
        }
      }
    }
  }
  .footer {
    border-top: 1px solid #E9E9E9;
    padding: 10px;
    text-align: center;
    button {
      width: 80px;
      &.save {
        background: linear-gradient(315deg, #ff846d 0%, #ff3973 100%);
        color: #fff;
      }
    }
  }
  ::v-deep .el-tabs__header {
    margin: 0;
    .el-tabs__nav-wrap {
      border-bottom: 1px solid #E9E9E9;
      &::after {
        display: none;
      }
      .el-tabs__item {
        font-size: 12px;
        line-height: 30px;
        height: 30px;
        margin: 0 20px;
        padding: 0;
        &:hover {
          color: #ff3973;
        }
        &.is-active {
          color: #ff3973;
          border-bottom: 1px solid #ff3973;
        }
      }
    }
    .el-tabs__active-bar {
      display: none;
    }
  }
}

</style>
